import { apiSlice } from '@/features/savedQueriesWidget/apiSlice';
import { joinSlice } from '@/features/joinModal/joinModalSlice';
import { dependantQueriesSlice } from '@/features/dependantQueries/dependantQueriesSlice';
import { publicDatasetApi } from '@/features/publicDatasets/publicDatasetApi';
import { queryColumnsApi } from '@/features/addWidgetModal/queryColumnsApi';
import { dashboardFiltersApi } from '@/features/addWidgetModal/filtersApi';
import { creditsApi } from '@/features/credits/apiSlice';
import { suggestionApi } from '@/features/suggestions/apiSlice';
import { inviteApi } from '@/features/dashboardShare/ShareDropdown/InviteTab/inviteApi';
import { permissionApi } from '@/permissions/permissionApi';
import { layerAggregateSlice } from '@/components/layers/LayerAggregate/layerAggregateSlice';
import { subscriptionManagementApi } from '@/features/subscrriptionmanagement/apiSlice';
import { subscriptionApi } from '@/features/subscription/apiSlice';
import { drilldownApi } from '@/features/drilldown/apiSlice';
import { datasourcesApi } from '@/features/datasources/apiSlice';
import { dashboardSlice } from '@/features/dashboard/dashboardSlice';
import { modalsSlice } from '@/features/modals/modalSlice';
import { dashboardApi } from '@/features/dashboard/apiSlice';
import { chartConfigurationApi } from '@/features/chart-configuration/apiSlice';
import { queryBuilderSlice } from '@/features/query-builder/queryBuilderSlice';
import { dashboardsSlice } from '@/features/dashboards/dashboardsSlice';
import { queryConfigurationApi } from '@/features/queryMetricsDimensionsConfig/apiSlice';
import { metricConfigSlice } from '@/features/queryMetricsDimensionsConfig/metricConfigSlice';
import { queryBuilderStepsSlice } from '@/features/query-builder-steps/queryBuilderStepsSlice';
import { queryBuilderQueriesApi } from '@/features/query-builder/queriesApiSlice';
import { queryBuilderSavedQueriesApi } from '@/features/query-builder/savedQueriesApiSlice';
import { fullQueryResultsApiSlice } from '@/features/query-builder/fullQueryResultsApiSlice';
import { categoriesApiSlice } from '@/features/categories/categoriesApiSlice';
import { zendeskApi } from '@/features/zendesk/apiSlice';
import { bucketFeedsApi } from '@/features/bucketFeeds/bucketFeedsApiSlice';
import { alertApi } from '@/features/alerts/alertApiSlice';
import { googleSheetsApi } from '@/features/google-sheets/googleSheetsApi';
import { zapierApiSlice } from '@/features/zapier/zapierApiSlice';
import { suggestedQueriesApiSlice } from '@/features/suggested-queries/suggestedQueriesApiSlice';
import { customerFacingDashboardApi } from '@/features/customer-facing-dashboards/apiSlice';
import { queryBuilderStepsUndoRedoSlice } from '@/features/query-builder-steps-undo-redo';
import { savedQueryFilterPresetsApi } from '@/features/saved-query-dashboard-filter-presets/apiSlice';
import datasource from './datasource';
import rows from './rows';
import layers from './layers';
import modals from './modals';
import map from './map';
import reactModal from './react_modal';
import views from './views';
import erDiagram from './er_diagram';
import shareHtml from './share_html';
import alerts from './alerts';
import { dashboardsReducer } from './dashboards';

export const rootReducer = {
  datasource,
  rows,
  layers,
  modals,
  react_modal: reactModal,
  views,
  erDiagram,
  shareHtml,
  dashboards: dashboardsReducer,
  map,
  alerts,
  [datasourcesApi.reducerPath]: datasourcesApi.reducer,
  [zendeskApi.reducerPath]: zendeskApi.reducer,
  [apiSlice.reducerPath]: apiSlice.reducer,
  [joinSlice.name]: joinSlice.reducer,
  [modalsSlice.name]: modalsSlice.reducer,
  [queryBuilderStepsUndoRedoSlice.name]: queryBuilderStepsUndoRedoSlice.reducer,
  [queryBuilderSlice.name]: queryBuilderSlice.reducer,
  [dashboardsSlice.name]: dashboardsSlice.reducer,
  [dashboardSlice.name]: dashboardSlice.reducer,
  [queryBuilderStepsSlice.name]: queryBuilderStepsSlice.reducer,
  [metricConfigSlice.name]: metricConfigSlice.reducer,
  [layerAggregateSlice.name]: layerAggregateSlice.reducer,
  [publicDatasetApi.reducerPath]: publicDatasetApi.reducer,
  [queryColumnsApi.reducerPath]: queryColumnsApi.reducer,
  [dashboardFiltersApi.reducerPath]: dashboardFiltersApi.reducer,
  [inviteApi.reducerPath]: inviteApi.reducer,
  [permissionApi.reducerPath]: permissionApi.reducer,
  [dependantQueriesSlice.name]: dependantQueriesSlice.reducer,
  [creditsApi.reducerPath]: creditsApi.reducer,
  [suggestionApi.reducerPath]: suggestionApi.reducer,
  [subscriptionManagementApi.reducerPath]: subscriptionManagementApi.reducer,
  [subscriptionApi.reducerPath]: subscriptionApi.reducer,
  [drilldownApi.reducerPath]: drilldownApi.reducer,
  [dashboardApi.reducerPath]: dashboardApi.reducer,
  [savedQueryFilterPresetsApi.reducerPath]: savedQueryFilterPresetsApi.reducer,
  [chartConfigurationApi.reducerPath]: chartConfigurationApi.reducer,
  [queryConfigurationApi.reducerPath]: queryConfigurationApi.reducer,
  [queryBuilderQueriesApi.reducerPath]: queryBuilderQueriesApi.reducer,
  [categoriesApiSlice.reducerPath]: categoriesApiSlice.reducer,
  [queryBuilderSavedQueriesApi.reducerPath]:
    queryBuilderSavedQueriesApi.reducer,
  [fullQueryResultsApiSlice.reducerPath]: fullQueryResultsApiSlice.reducer,
  [bucketFeedsApi.reducerPath]: bucketFeedsApi.reducer,
  [alertApi.reducerPath]: alertApi.reducer,
  [suggestedQueriesApiSlice.reducerPath]: suggestedQueriesApiSlice.reducer,
  [googleSheetsApi.reducerPath]: googleSheetsApi.reducer,
  [zapierApiSlice.reducerPath]: zapierApiSlice.reducer,
  [customerFacingDashboardApi.reducerPath]: customerFacingDashboardApi.reducer,
};
